<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 17 15">
    <path
      d="M12.9329 8.89669C13.1356 9.35145 13.2379 9.85733 13.2379 10.4126C13.2379 11.5953 12.7761 12.5207 11.8533 13.1861C10.9288 13.8515 9.65354 14.1846 8.02575 14.1846C6.74535 14.1846 5.47671 13.9211 4.21921 13.3935C3.91972 13.2678 3.73372 12.9694 3.73372 12.6446C3.73372 11.9972 4.4412 11.5855 5.04551 11.8178C5.96467 12.1711 6.89807 12.3479 7.84596 12.3479C10.0942 12.3479 11.2214 11.7028 11.2293 10.4117C11.234 10.1499 11.1858 9.88987 11.0877 9.64713C10.9896 9.4044 10.8435 9.18393 10.6582 8.99892L10.5525 8.89581H1.34006C0.85332 8.89581 0.45874 8.50123 0.45874 8.01449C0.45874 7.52775 0.85332 7.13317 1.34006 7.13317H15.4412C15.9279 7.13317 16.3225 7.52775 16.3225 8.01449C16.3225 8.50123 15.9279 8.89581 15.4412 8.89581H12.9329V8.89669ZM9.29623 6.23804C9.30429 6.24081 9.3023 6.25273 9.29377 6.25273H4.54129C4.53941 6.25273 4.5376 6.25203 4.53621 6.25076C4.38266 6.11053 4.24155 5.95727 4.11445 5.79268C3.73372 5.30091 3.54336 4.7069 3.54336 4.00713C3.54336 2.91782 3.95405 1.99155 4.77456 1.22833C5.59683 0.465107 6.86681 0.0834961 8.58627 0.0834961C9.71615 0.0834961 10.8039 0.303072 11.8482 0.742225C12.1326 0.861802 12.3072 1.14637 12.3072 1.45486C12.3072 2.07503 11.6268 2.47455 11.0374 2.28173C10.3399 2.05354 9.60396 1.93955 8.82951 1.93955C6.64384 1.93955 5.55188 2.62875 5.55188 4.00713C5.55188 4.37728 5.74401 4.69985 6.12827 4.9757C6.51252 5.25155 7.54983 5.63669 7.54983 5.63669L9.29623 6.23804Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
